import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ForgotUsername.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ForgotUsername extends Component {
	openCalendly = () => {
		window.Calendly.showPopupWidget('https://calendly.com/showtix4u');
		// Accessibility - Add focus on iframe when opening Calendly
		let calendlyIframe = document.querySelectorAll('.calendly-popup iframe')[0];
		setTimeout(() => {
			calendlyIframe.setAttribute('title', 'Showtix Support');
			calendlyIframe.setAttribute('tabIndex', -1);
			calendlyIframe.focus();
		}, 1000);
	};
	
    render() {
		return (
			<div className="showtix-section container">
				<div className="row">
					<div className="col-12">
						<h1>{strings.title}</h1>
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-lg-8">
						<p>
						{ReactHtmlParser(strings.content)}
						<button
							onClick={() => this.openCalendly()}
							style={{
								background: 'none',
								border: 'none',
								display: 'inline',
								padding: '0 0 0 3px',
								color: '#5c649b',
							}}
						>
							HERE
						</button>.
						</p>
						<Link className="showtix-button showtix-background__primary-2" to="/login">{strings.goBack}</Link>
					</div>
				</div>
			</div>
		);
  	}
}

export default ForgotUsername;



// WEBPACK FOOTER //
// ./src/components/ForgotUsername/ForgotUsername.js